import { appUrl } from 'utils/wrappers';

import Base from 'app/models/base';

const User = Base.extend({
  urlRoot: appUrl('users'),
  rootKey: 'user',

  parse(res) {
    const response = { ...res };

    const childModels = [];
    if (response.children) {
      response.children.forEach(childRaw => childModels.push(new User(childRaw)));
    }

    response.children = childModels;

    return response;
  },

  isLoggedIn() {
    return !!this.id;
  },
});

export default User;



// WEBPACK FOOTER //
// ./app/models/user.js